module.exports = __webpack_public_path__ + "img/920d3fc.jpg";